<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-btn text @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
          Volver
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <div class="pa-4">
          <v-container>
            <v-row align="center" no-gutters class="mb-4">
              <v-col class="mr-4">
                <v-text-field
                  v-model="searchFolio"
                  rounded
                  filled
                  dense
                  hide-details
                  background-color="transparent"
                  color="secondary"
                  label="Buscar por folio"
                  append-icon="mdi-magnify"
                  class="search-input"
                ></v-text-field>
              </v-col>
              <v-col>
                <v-select
                  v-model="searchEquipo"
                  :items="itemsDisponiblesEnHistorico"
                  rounded
                  filled
                  dense
                  hide-details
                  clearable
                  background-color="transparent"
                  color="secondary"
                  item-color="secondary"
                  label="Filtrar por equipo"
                  class="search-input"
                ></v-select>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="itemsFiltrados"
                  class="ui-module-table"
                  hide-default-footer
                  disable-pagination
                >
                  <template v-slot:[`item.equipoAsignado`]="{ item }">
                    <span v-if="Array.isArray(item.equipoAsignado)">
                      {{ item.equipoAsignado.map((eq) => eq.Equipo?.CatItem?.item || '').join(', ') }}
                    </span>
                    <span v-else>{{ item.equipoAsignado }}</span>
                  </template>
                  <template v-slot:[`item.file`]="{ item }">
                    <v-icon v-if="item.file" color="success">mdi-check-circle</v-icon>
                    <v-icon v-else color="error">mdi-close-circle</v-icon>
                  </template>
                  <template v-slot:[`item.acciones`]="{ item }">
                    <v-btn icon color="secondary" small v-if="item.file" :href="item.file" download>
                      <v-icon>mdi-download</v-icon>
                    </v-btn>
                  </template>
                  <template v-slot:[`item.opciones`]="{ item }">
                    <span class="d-flex align-center">
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <span v-bind="attrs" v-on="on">
                            <IconButton
                              class="mr-2"
                              variant="secondary"
                              icon="mdi-text-box-search-outline"
                              @click="openListadoEquiposAsignadosDialog(item)"
                            />
                          </span>
                        </template>
                        <span>Listado de Equipos Asignados</span>
                      </v-tooltip>
                    </span>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import { DIALOG_TYPES } from '@/plugins/dialog-types'
import IconButton from '@/components/base/IconButton.vue'

export default {
  components: {
    IconButton,
  },
  props: {
    id: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      headers: [
        { text: 'Fecha de Solicitud', value: 'fechaSolicitud' },
        { text: 'Fecha de Asignación', value: 'fechaAsignacion' },
        { text: 'Folio de Resguardo', value: 'folioResguardo' },
        { text: 'Archivo', value: 'file', sortable: false },
        { text: 'Equipo seleccionado', value: 'equipoAsignado' },
        { text: 'Observaciones', value: 'observaciones' },
        { text: 'Opciones', value: 'opciones', align: 'center', width: '10%', sortable: false },
      ],
      DIALOG_TYPES,
      searchFolio: '',
      searchEquipo: '',
    }
  },
  computed: {
    ...mapGetters('asignacionEquipo', {
      asignacionesEquipo: 'getAsignacionesEquipo',
    }),
    items() {
      return this.asignacionesEquipo.filter((a) => a.fk_idPersonal === this.id)
    },
    itemsDisponiblesEnHistorico() {
      const nombres = new Set()
      this.items.forEach((a) => {
        if (Array.isArray(a.equipoAsignado)) {
          a.equipoAsignado.forEach((eq) => {
            const nombre = eq.Equipo?.CatItem?.item
            if (nombre) nombres.add(nombre)
          })
        }
      })
      return [...nombres].sort()
    },
    itemsFiltrados() {
      const folio = (this.searchFolio || '').toLowerCase().trim()
      const equipo = (this.searchEquipo || '').toLowerCase()
      return this.items.filter((a) => {
        const coincideFolio = !folio || (a.folioResguardo || '').toLowerCase().includes(folio)
        const equipoTexto = Array.isArray(a.equipoAsignado)
          ? a.equipoAsignado.map((eq) => eq.Equipo?.CatItem?.item || '').join(' ')
          : String(a.equipoAsignado || '')
        const coincideEquipo = !equipo || equipoTexto.toLowerCase().includes(equipo)
        return coincideFolio && coincideEquipo
      })
    },
  },
  mounted() {
    this.fetchAsignacionEquipoByPersonal(this.id)
  },
  methods: {
    ...mapActions('asignacionEquipo', ['fetchAsignacionEquipoByPersonal']),
    ...mapMutations('dialog', ['SET_DIALOG']),

    openListadoEquiposAsignadosDialog(item) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.LISTADO_EQUIPOS_ASIGNADOS,
        props: {
          asignacionEquipo: item,
        },
      })
    },
  },
}
</script>

<style scoped>
/* Tabla de datos */
::v-deep .v-data-table {
  background: transparent !important;
  color: #e0e0e0 !important;
}

::v-deep .v-data-table-header {
  background: rgba(255, 159, 67, 0.15) !important;
}

::v-deep .v-data-table-header th {
  color: #e0e0e0 !important;
  font-weight: 600 !important;
  border-bottom: 2px solid rgba(255, 159, 67, 0.3) !important;
}

::v-deep .v-data-table tbody tr {
  transition: all 0.3s ease;
}

::v-deep .v-data-table tbody tr:hover {
  background: rgba(255, 159, 67, 0.1) !important;
}

::v-deep .v-data-table tbody td {
  color: #e0e0e0 !important;
  border-bottom: 1px solid rgba(255, 159, 67, 0.1) !important;
}

::v-deep .v-data-footer {
  background: rgba(46, 36, 22, 0.4) !important;
  border-top: 1px solid rgba(255, 159, 67, 0.2) !important;
  color: #e0e0e0 !important;
}

/* Inputs de búsqueda */
::v-deep .search-input .v-input__slot {
  border-radius: 12px !important;
  border: 1px solid rgba(255, 159, 67, 0.25) !important;
  background: rgba(16, 16, 30, 0.35) !important;
}

::v-deep .search-input .v-input__slot:hover {
  border-color: rgba(255, 159, 67, 0.45) !important;
}

::v-deep .search-input .v-input__control {
  background: transparent !important;
  border-radius: 12px;
  border: none !important;
  box-shadow: none !important;
}

::v-deep .search-input .v-input__slot input,
::v-deep .search-input .mdi-magnify {
  color: #e0e0e0 !important;
}

::v-deep .search-input .v-label {
  color: rgba(224, 224, 224, 0.7) !important;
}

::v-deep .search-input.v-input--is-focused .v-label {
  color: #ffbe76 !important;
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px;
  text-transform: none;
  font-weight: 600;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

::v-deep .v-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(255, 159, 67, 0.3);
}

::v-deep .v-btn.v-btn--icon {
  background: rgba(255, 159, 67, 0.1);
  border: 1px solid rgba(255, 159, 67, 0.2);
}

::v-deep .v-btn.v-btn--icon:hover {
  background: rgba(255, 159, 67, 0.2);
  border-color: #ff9f43;
}

::v-deep .v-icon {
  color: #ffbe76 !important;
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  color: #ff9f43 !important;
  transform: scale(1.2);
}

::v-deep .v-tooltip__content {
  background: rgba(46, 36, 22, 0.95) !important;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 159, 67, 0.3);
  border-radius: 8px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.5);
  color: #e0e0e0 !important;
  padding: 8px 12px;
  font-weight: 500;
}

a {
  color: #ff9f43 !important;
  text-decoration: none;
}

a:hover {
  color: #ffbe76 !important;
  text-decoration: underline;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 4px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb {
  background: rgba(255, 159, 67, 0.4);
  border-radius: 4px;
}

::v-deep .v-data-table__wrapper::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 159, 67, 0.6);
}
</style>
